module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-step-1-f2145cbef74ee477873ee340bd42c055.svg";